import api from "../api";
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';

export interface TipoNaoPrevisto {
    id: string;
    codigo: number;
    nome: string;
}

export interface OrcadoAnoNaoPrevisto {
    id: string;
    index: number;
    ano: number;
    valorAprovadoOnp?: number;
    valorAprovadoCnp?: number;
    valorDolar?: number;
    valorEuro?: number;
}

export interface ProjetoNaoPrevisto {
    departamento: string;
    area: string;
    diretoria: string;
    nome: string;
    codigo: string;
    classificacaoContabil: string;
}

export const getAllTipoNaoPrevisto = () =>
    api.get<TipoNaoPrevisto[]>('NaoPrevistoParametros/TipoNaoPrevisto');

export const getAllTipoNaoPrevistoOptions = () =>
    getAllTipoNaoPrevisto().then(tipos => (tipos || []).map(tipo => ({ text: tipo.nome, value: tipo.id && tipo.id.toString() })));

export const createTipoNaoPrevisto = (values: any) =>
    api.post<TipoNaoPrevisto[]>('NaoPrevistoParametros/TipoNaoPrevisto', values);

export const updateTipoNaoPrevisto = (values: any) =>
    api.put<TipoNaoPrevisto[]>('NaoPrevistoParametros/TipoNaoPrevisto', values);

export const deleteTipoNaoPrevisto = (id: string) =>
    api.delete<any>(`NaoPrevistoParametros/TipoNaoPrevisto/${id}`);

export const getAllOrcadoAnoNaoPrevisto = () =>
    api.get<OrcadoAnoNaoPrevisto[]>('NaoPrevistoParametros/OrcadoAnoNaoPrevisto');

export const getOrcadoAnoNaoPrevistoByAno = (ano: number) =>
    api.get<OrcadoAnoNaoPrevisto>(`NaoPrevistoParametros/OrcadoAnoNaoPrevistoByAno/${ano}`);

export const createOrcadoAnoNaoPrevisto = (values: any) =>
    api.post<OrcadoAnoNaoPrevisto[]>('NaoPrevistoParametros/OrcadoAnoNaoPrevisto', values);

export const updateOrcadoAnoNaoPrevisto = (values: any) =>
    api.put<OrcadoAnoNaoPrevisto[]>('NaoPrevistoParametros/OrcadoAnoNaoPrevisto', values);

export const getProjetosNaoPrevisto = (id: string) =>
    api.get<any>(`NaoPrevistoParametros/Projetos/${id}`);

export const GetConfiguracao = () => api.get<any[]>('NaoPrevistoParametros/configuracao');
export const UpdateConfiguracao = values => api.put('NaoPrevistoParametros/configuracao', values);

export const exportaModelo = () => {
    let urlBase = window.location.origin;
    let nomeArquivo = '';

    urlBase += `/api/NaoPrevistoParametros/Projetos/modeloImportacao`;
    nomeArquivo = 'modelo_importacao_projetos.xlsx';

    trackPromise(
        Axios.get(urlBase, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => generateElementDownload(resp, nomeArquivo)),
    );
}

//Private
function generateElementDownload(resp: any, nomeArquivo: string) {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    var element = document.getElementById('downloadElement');
    if (element) {
      element.outerHTML = '';
    }
  }